



































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  UserPermission
} from "@/shared/types";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { usePartnerStore } from "@/admin/store/partner";

@Component({
  components: {
    Input,
    ErrorSummary
  }
})
export default class AchBranding extends Vue {
  $router: VueRouter;
  $validator: Validator;

  partnerStore = usePartnerStore();
  rolePermissionsStore = useRolePermissionsStore();

  isSubmitting = false;
  companyName = "";

  @Prop() partnerId: number;

  mounted () {
    this.partnerStore.loadAchCompanyName(this.partnerId);
  }

  @Watch("partnerStore.achCompanyNameLoaded")
  onAchCompanyNameLoaded () {
    if (this.partnerStore.achCompanyNameLoaded) {
      this.companyName = this.partnerStore.achCompanyName;
    }
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  @Watch("partnerId")
  onPartnerIdChanged (partnerId) {
    this.partnerStore.loadAchCompanyName(partnerId);
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.isSubmitting = true;
          this.partnerStore.saveAchCompanyName({
                partnerId: this.partnerId,
                companyName: this.companyName
              })
              .then(() => this.isSubmitting = false);
        });
  }
}
